import $ from 'jquery'
import {customerNameLower, projectNameLower} from '../util/pluralizeUtils'
import messageResource from '../messageResource'
import {escapeHtmlSymbols} from '../atUtils'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'
import {CustomersProjectsSelectionQualifier} from 'constants'

export default function ReportConfigs () {}

ReportConfigs.prototype.init = function(reports, users, userGroups, timeZoneGroups, cpList, customersWithMaIds, projectsWithMaIds, leaveTypesMap, manageableUserIds)
{
    this.reports = reports
    this.users = users
    this.userGroups = userGroups
    this.timeZoneGroups = timeZoneGroups
    this.cpList = cpList
    this.customersWithMaIds = customersWithMaIds
    this.projectsWithMaIds = projectsWithMaIds
    this.leaveTypesMap = leaveTypesMap
    this.manageableUserIds = manageableUserIds

    this.reportParamsStringBuilder = new ATReportParamsStringBuilder({
        data: {
            users: this.users,
            timeZoneGroups: this.timeZoneGroups,
            userGroups: this.userGroups,
            cpList: this.cpList,
            leaveTypesMap: this.leaveTypesMap,
            manageableUserIds: this.manageableUserIds,
            customersWithMaIds: customersWithMaIds,
            projectsWithMaIds: projectsWithMaIds,
        },
        dataFormat: SystemSettings.dateFormat.replace(/MMMM/, 'MMM')
    })

    const titleStrings = this.buildTitlesStrings();
    const paramStrings = this.buildParamsStringsForReportConfigs();
    const dateRangeStrings = this.buildDateParamStringsForReportConfigs();

    for (let reportId in paramStrings) {
        if (paramStrings.hasOwnProperty(reportId)) {
            $("#" + reportId + " .type-title" ).html(titleStrings[reportId]);
            $("#" + reportId + " .otherParams" ).html(paramStrings[reportId]);
            $("#" + reportId + " .date-filter" ).html(dateRangeStrings[reportId]);
        }
    }
};

ReportConfigs.prototype.buildTitlesStrings = function(){
    var self = this;
    var reportTitlesStrings = [];
    var nodeIdBase = "reportConfig_";
    for(var i = 0; i < self.reports.length; i++) {
        reportTitlesStrings[nodeIdBase + self.reports[i].id] = self.getTitleString(self.reports[i]);
    }
    return reportTitlesStrings;
};

ReportConfigs.prototype.getTitleString = function(reportConfig){
    var title = messageResource.getMessage(ReportChartNames[reportConfig.type]);
    if (reportConfig.isChart){
        var self = this;
        title += " " + messageResource.getMessage("saved_reports.charts_title.part2",
                                                  [messageResource.getEscapedMessage(this.getByTextForCharts(self.getParameters(reportConfig)))]);
    }
    return title;
};

ReportConfigs.prototype.getByTextForCharts = function(chartParams){
    switch (chartParams.groupingLevel){
        case ReportGroupingLevel.USER: return "report.common.users";
        case ReportGroupingLevel.USER_GROUP :  return "common.User_Groups";
        case ReportGroupingLevel.TIME_ZONE_GROUP :  return "common.Time_Zone_Groups";
        case ReportGroupingLevel.CUSTOMER : return "common.Customers";
        case ReportGroupingLevel.PROJECT : return "common.Projects";
        case ReportGroupingLevel.BILLING_TYPE : return "report.common.billing_types";
        case ReportGroupingLevel.DATE : return "report.common.dates";
        case ReportGroupingLevel.WEEK : return "report.common.weeks";
        case ReportGroupingLevel.MONTH : return "report.common.months";
        case ReportGroupingLevel.LEAVE_TYPE: return "report.common.leave_types";
    };
};

ReportConfigs.prototype.buildParamsStringsForReportConfigs = function( ) {
    var self = this;
    var nodeIdBase = "reportConfig_";
    var reportParamsStrings = [];
    for(var i = 0; i < self.reports.length; i++) {
        reportParamsStrings[nodeIdBase + self.reports[i].id] = self.getParamsString(self.reports[i]);
    }
    return reportParamsStrings;
};

ReportConfigs.prototype.buildDateParamStringsForReportConfigs = function ()
{
    var self = this;
    var nodeIdBase = "reportConfig_";
    var reportDateRangeStrings = [];
    for( var i = 0; i < self.reports.length; i++ )
    {
        if( self.reports[i].type != "ESTIMATED_VS_ACTUAL" && self.reports[i].type != "PTO_BALANCE" && self.reports[i].type != "SICK_DAYS_BALANCE" )
            reportDateRangeStrings[nodeIdBase + self.reports[i].id] = self.formatHTML(
                    self.reportParamsStringBuilder.getDateRangeParamString( self.getParameters(self.reports[i]).dateRangeSelection ),
                    "dateRange",
                    self.reportParamsStringBuilder.getDateRangeDetailsString( self.getParameters(self.reports[i]).dateRangeSelection ) );
        else
            reportDateRangeStrings[nodeIdBase + self.reports[i].id] = self.formatHTML(
                    self.reportParamsStringBuilder.getEvaDateParamString( self.getParameters(self.reports[i]).dateSelection ),
                    "dateRange",
                    self.reportParamsStringBuilder.getEvaDateDetailsString(self.getParameters(self.reports[i]).dateSelection ) );
    }
    return reportDateRangeStrings;
};

ReportConfigs.prototype.getParameters = function(report){

    if(report.isChart){
        return report.params.dataParameters;
    }
    return report.params;
};

ReportConfigs.prototype.getParamsString = function(reportConfig) {
    var DELIMITER = ";"
    var availableUserIds = this.users
    if (!!reportConfig.reportAuthorizationInfo) {
        availableUserIds = filterArrayByArrayOfIds(this.users, reportConfig.reportAuthorizationInfo.availableUserIds)
    }
    var reportParamsStringBuilderWithAuthInfos = new ATReportParamsStringBuilder({
        data: {
            users: availableUserIds,
            timeZoneGroups: this.timeZoneGroups,
            userGroups: this.userGroups,
            cpList: this.cpList,
            leaveTypesMap: this.leaveTypes,
            manageableUserIds: this.manageableUserIds,
            projectsWithMaIds: this.projectsWithMaIds,
        },
        dataFormat: SystemSettings.dateFormat.replace(/MMMM/, 'MMM'),
        reportAuthorizationInfo: reportConfig.reportAuthorizationInfo,
        userFormatter: reportConfig.isChart ? BaseReportFormatUtils.reportUserFormatterWithoutUsername : BaseReportFormatUtils.reportUserFormatterWithUsernameIfNeeded
    })

    if (reportConfig.type === "STAFF_PERFORMANCE" ||
        reportConfig.type === "TIME_TRACK_IN_DETAIL" ||
        reportConfig.type === "COST_OF_WORK" ||
        reportConfig.type === "TOTAL_WORKING_HOURS" ||
        reportConfig.type === "APPROVED_WORKING_HOURS" ||
        reportConfig.type === "BILLABLE_AMOUNTS") {
        return this.getUserSelectionParamString(this.getParameters(reportConfig).userSelection, reportParamsStringBuilderWithAuthInfos, DELIMITER) +
               this.getCPSelectionParamString(this.getParameters(reportConfig).customersProjectsSelection)
    }

    if (reportConfig.type === "ESTIMATED_VS_ACTUAL" ||
        reportConfig.type === "PROFIT_LOSS" ||
        reportConfig.type === "INVOICING" ||
        reportConfig.type === "BILLING_SUMMARY") {
        return this.getCPSelectionParamString(this.getParameters(reportConfig).customersProjectsSelection)
    }

    if (reportConfig.type === "OVERTIME" ||
        reportConfig.type === "OVERTIME_HOURS") {
        return this.getUserSelectionParamString(this.getParameters(reportConfig).userSelection, reportParamsStringBuilderWithAuthInfos)
    }

    if (reportConfig.type === "PTO_BALANCE" ||
        reportConfig.type === "SICK_DAYS_BALANCE") {
        return this.getUserSelectionParamString(this.getParameters(reportConfig).userSelection, reportParamsStringBuilderWithAuthInfos)
    }

    if (reportConfig.type === "LEAVE_TIME" ||
        reportConfig.type === "LEAVE_HOURS") {
        return this.getUserSelectionParamString(this.getParameters(reportConfig).userSelection, reportParamsStringBuilderWithAuthInfos, DELIMITER) +
               this.getLeaveTypeSelectionParamString(this.getParameters(reportConfig).leaveTypeSelection)
    }
}

ReportConfigs.prototype.formatHTML = function(title, className, altTitle) {
    let result = "<span class=\""
    result += className + "\""
    if (altTitle)
        result += " title=\"" + escapeHtmlSymbols(altTitle) + "\""
    result += ">" + escapeHtmlSymbols(title) + "</span>"
    return result.toString()
}


ReportConfigs.prototype.getUserSelectionParamString = function(userSelection, reportParamsStringBuilderWithAuthInfos, delimiter) {
    delimiter = !!delimiter ? delimiter : ""
    return this.formatHTML(
        reportParamsStringBuilderWithAuthInfos.getUserSelectionParamString(userSelection) + delimiter,
        reportParamsStringBuilderWithAuthInfos.getUserSelectionClass(userSelection),
        reportParamsStringBuilderWithAuthInfos.getUserSelectionDetailsString(userSelection))
}

ReportConfigs.prototype.getCPSelectionParamString = function( cpSelection ) {
    var CLASS_NAME = "cp-selector";
    var CUSTOMERS_CLASS = "customers-filter";
    var PROJECTS_CLASS = "projects-filter";
    var ERROR_CLASS_NAME = "error-cp-selector";
    var AND_DELIMITER = this.formatHTML("&", "delimiter");

    var customerFormatter = {
        format: function(customer) {
            return customer.name;
        }
    };

    var projectFormatter = {
        format: function(project) {
            return project.name;
        }
    };

    if ( cpSelection.qualifier == CustomersProjectsSelectionQualifier.ALL )
        return this.formatHTML(messageResource.getMessage("saved_reports.cp_selector.all_projects"), CLASS_NAME);

    if( cpSelection.qualifier == CustomersProjectsSelectionQualifier.ALL_ACTIVE )
        return this.formatHTML( messageResource.getMessage("saved_reports.cp_selector.all_active_projects"), CLASS_NAME );
    else {
        var customers = this.reportParamsStringBuilder.getFilteredCustomers(cpSelection);
        var projects = this.reportParamsStringBuilder.getFilteredProjects(cpSelection);

        if( customers.length == 0 && projects.length == 0 )
            return this.formatHTML( messageResource.getMessage( "saved_reports.cp_selector.emty_selection" ),
                                    CLASS_NAME + " " + ERROR_CLASS_NAME );

        var message, alt, key, params;

        if( customers.length == 1 && projects.length == 0 )
        {
            key = "saved_reports.cp_selector.single_element.customer";
            params = [customerFormatter.format( customers[0] )];

            message = messageResource.getMessage(key, params);
            alt = messageResource.getMessage(key, params);

            return this.formatHTML( message, CUSTOMERS_CLASS, alt );
        }

        if( projects.length == 1 && customers.length == 0 )
        {
            key = "saved_reports.cp_selector.single_element.project";
            params = [projectFormatter.format( projects[0] )];

            message = messageResource.getMessage(key, params);
            alt = messageResource.getMessage(key, params);

            return this.formatHTML( message, PROJECTS_CLASS, alt );
        }

        const getCustomersPart = (customers, availableSuffix, activeProjectsSuffix) => {
            const title = customers.length.toString()
                          + " "
                          + customerNameLower(customers.length)
                          + " "
                          + messageResource.getMessage("saved_reports.cp_selector.multiple_customer",
                                                        [
                                                            availableSuffix,
                                                            activeProjectsSuffix
                                                        ])
            const altTitle = this.reportParamsStringBuilder.getTitle(
                messageResource.getMessage("saved_reports.cp_selector.title_header.customers"),
                customers,
                customerFormatter
            )

            return this.formatHTML(title, CUSTOMERS_CLASS, altTitle)
        }

        const getProjectsPart = (projects) => {
            const title = projects.length.toString() + " " + projectNameLower(projects.length)
            const altTitle = this.reportParamsStringBuilder.getTitle(
                messageResource.getMessage( "saved_reports.cp_selector.title_header.projects"),
                projects,
                projectFormatter
            )

            return this.formatHTML(title, PROJECTS_CLASS, altTitle)
        }

        var customersPart = "", projectsPart = "";
        if (customers.length > 0)
        {
            customersPart = getCustomersPart(customers, "", "");
        }

        if (projects.length > 0)
        {
            projectsPart = getProjectsPart( projects );
        }
        return customersPart + (customersPart.length > 0 && projectsPart.length > 0 ? AND_DELIMITER : "") + projectsPart;
    }
};

ReportConfigs.prototype.getLeaveTypeSelectionParamString = function ( leaveTypeSelection )
{
    return this.formatHTML(
            this.reportParamsStringBuilder.getLeaveTypeSelectionParamString( leaveTypeSelection ),
            this.reportParamsStringBuilder.getLeaveTypeSelectionClass( leaveTypeSelection ) ,
            this.reportParamsStringBuilder.getLeaveTypeSelectionDetailsString( leaveTypeSelection ) );
};


// WEBPACK FOOTER //
// ./web/js/reports/ReportConfigs.js